import React from 'react';
import { toast } from 'react-toastify';
import EntityFilter from '../../../components/common/EntityFilter';
import services from '../../../services';
import { Button } from '@progress/kendo-react-buttons'
import $ from 'jquery'
var moment = require('moment')

const dateFormat = "YYYY-MM-DD";

let listdefaultRequest = { "Filters": null, "SortBy": "", "IsSortTypeDESC": false, "IsPagination": false, "Page": 1, "PageSize": 100 }

let defaultRequest = {
    "Filters": null,
    "SortBy": "",
    "IsSortTypeDESC": true,
    "IsPagination": false,
    "Page": 2,
    "PageSize": 2
};

class TransferirModal extends React.Component{

    state={
        entity_details: {
            busEntidade: {},
            currentEntityBalance: 0,
            billingAddress: []
        },
        form:{},
        amountDetails: [],
        entityId : '',
        resetEntityList : false,
        PaymentMethod_id: null,
        RequiredField:{
            "total_cr": "montante total",
            "bank": "banco",
            
        }
    }

    componentDidMount() {
        this.getcurrencyList();
        this.getTaxList();
        this.getTransMethods();
    
    }

    componentDidUpdate(prevProp){
        if (prevProp.date !== this.props.date) {
            this.resetEntityDetail()
        }
    }

    /* Para métodos trans do servidor */
    getTransMethods = async () => {
        let link = "Revenue/TransactionMethod/GetAll"
        let res = await services.apiCall.requestApi(link, defaultRequest);
        if (res) {
            this.setState({
                TransMethods_list: res
            });
        }
    }

    

    /*
    Para obter a lista de moedas do servidor 
    */
    getcurrencyList = async () => {
        let link = "Revenue/Currency/GetAll"
        let res = await services.apiCall.requestApi(link, defaultRequest);
        if (res) {
            this.setState({
                currency_list: res
            });
        }
    }
    /* Para obter a lista de impostos do servidor */
    getTaxList = async () => {
        let link = "Revenue/Tax/GetAll"
        let res = await services.apiCall.requestApi(link, defaultRequest);
        if (res) {
            this.setState({
                tax_list: res
            });
        }
    }

    // para armazenar o valor do formulário

    handelChange = (e) => {
        let form = { ...this.state.form }
        form[e.target.name] = e.target.value;
        this.setState({
            form
        })
    }

    // para verificar e salvar saldo

    AddAdvance = async () => {
        let form = { ...this.state.form };
        let {RequiredField}= this.state; 
        if(!this.state.entityId){
           toast.error("O campo entidade é de preenchimento obrigatório ");
           return; 
        }
        else{
            for(var key in RequiredField){
            
                if(!Object.keys(form).includes(key) && !form[key]){
                    toast.error("O campo "+RequiredField[key]+" é de preenchimento obrigatório ");
                    
                    return;
                }
                        
            }
        }
        if (this.props.general_balance && (parseFloat(form.total_cr) > parseFloat(this.props.general_balance))) {
            toast.error("Você tem apenas " + services.money.format(this.props.general_balance) + " em sua conta geral");
            return;
        }
        if (parseFloat(form.total_cr) <= 0) {
            toast.error('Por favor, forneça valor positivo a ser adicionado');
            return;
        }
        
        let date = moment(new Date()).format(dateFormat);
        let request = {
            entity_id: parseInt(this.state.entity_details.busEntidade.nifap),
            trans_no: parseInt(form.trans_no),
            trans_type: "CR",
            trans_msg: form.trans_msg,
            total_cr: parseFloat(form.total_cr),
            trans_date: date,
            currency_id: form.currency_id ? parseInt(form.currency_id) : 4,
            Comment: form.Comment,
            trans_method_id: this.state.PaymentMethod_id ? parseInt(this.state.PaymentMethod_id) : 7,
            bank: form.bank,
            move_from_general: 1,
            bead_no: parseInt(form.bead_no),
            transactionDetail: [],
            invoice_id: null,
            local: null // window.localStorage.getItem('Local')
        }

        let api = "Revenue/AddBalance";
        let res = await services.apiCall.requestApi(api, request, 'post');
        let entity_details = {...this.state.entity_details}
        entity_details["busEntidade"] = {}
        entity_details["currentEntityBalance"] = 0
        entity_details["billingAddress"] = []

        if (res) {
            this.setState({
                form: {},
            }, () => {
                this.resetEntityDetail()
                this.props.closePopup()
            });
        }
    }

    resetEntityDetail = () =>{
        let entity_details = {...this.state.entity_details}
        entity_details["busEntidade"] = {}
        entity_details["currentEntityBalance"] = 0
        entity_details["billingAddress"] = []

        this.setState({entity_details,resetEntityList:!this.state.resetEntityList})
    }

    closePopup = () => {
        this.resetEntityDetail()
        $("#transferir-valor-modal").trigger('click');
    }

    // para definir método de pagamento

    setPaymentMethodid = (id) => {
        //console.log(id);
        this.setState({
            PaymentMethod_id: id
        })
    }

    // para manipular entidade e obter detalhes da entidade

    handleEntitySelect = async (entity_id) => {
        let Request = {};
        console.log("Entityfunction ", Request)
        this.setState({
            entity_details: {
                busEntidade: {},
                currentEntityBalance: 0,
                billingAddress: []
            }
        });
        if(!entity_id)
            return 
        Request.entityId = parseInt(entity_id);
        let link = "/Revenue/getEntityDetail"
        let res = await services.apiCall.requestApi(link, Request);
        if (res) {
            this.setState({
                entity_details: res,
                entityId:entity_id
            });
        }
    }
        
    render(){
        return(
            <>
                <div className="modal-content">
                    <div className="modal-header">
                        <h4 className="modal-title pl-0">{"Adicionar valor"}</h4>
                        <Button className="success btn-ivdp-primary mr-2" primary={true} onClick={() => this.AddAdvance()}>{"Adicionar"}</Button>
                        <Button className="remoove mr-2 k-primary btn-ivdp-secondary btn-theme" onClick={() => this.closePopup()} >Cancelar</Button>
                        {/* <span onClick={() => this.canclePopup()} className="remoove btn-ivdp-primary mr-2">Cancelar</span>  */
                        }
                    </div>
                    {
                        this.state.entity_details &&
                        <div className="modal-body">
                            <div className="row" style={{ marginTop: "20px" }}>
                                <div className="col-md-6">
                                    <p><strong>Nº Entidade</strong></p>
                                    <p>{this.state.entity_details.busEntidade.nifap}</p>
                                </div>
                                <div className="col-md-6">
                                    <p className="k-mb-0"><strong>Entidade</strong></p>
                                    <EntityFilter resetEntityList={this.state.resetEntityList} newClass="transferir-ant-select" returnKey="nifap" getselectedEntity={(val)=>this.handleEntitySelect(val)} />
                                </div>
                            </div>
                            <div className="row" style={{ marginTop: "20px" }}>
                                <div className="col-md-4">
                                    <p><strong>Saldo atual</strong></p>
                                    <p>{services.money.format(this.state.entity_details.currentEntityBalance)} </p>
                                </div>
                                <div className="col-md-4">
                                    <p><strong>Saldo cativo</strong></p>
                                    <p>{services.money.format(this.state.entity_details.captive_balance)}</p>
                                </div>
                                <div className="col-md-4">
                                    <p><strong>Acumulado anterior</strong></p>
                                    <p>{services.money.format(this.state.entity_details.accumulated_previous)}</p>
                                </div>
                            </div>
                            {
                                this.state.entity_details.busEntidade.nifap &&
                                <div className="row">
                                <div className="col-md-4">
                                    <div className="input-box  active-grey">
                                        <label className="input-label">Montante total</label>
                                        <input type="number" className="input-1"
                                            name="total_cr"
                                            min={0}
                                            onChange={this.handelChange}
                                            value={this.state.form.total_cr || ""} />
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="input-box active-grey">
                                        {
                                            this.state.currency_list &&
                                            <select name="currency_id"
                                                className="custome-drop-down"
                                                defaultValue={this.state.form.currency_id || 4}
                                                onChange={(e) => this.handelChange(e)} >
                                                {

                                                    this.state.currency_list.map((row, i) => (
                                                        <option value={row.id} key={i}>{row.currency}</option>
                                                    ))
                                                }
                                            </select>
                                        }
                                        
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="input-box  active-grey">
                                        <label className="input-label">Banco</label>
                                        <input type="text" className="input-1"
                                            name="bank"
                                            onChange={this.handelChange}
                                            value={this.state.form.bank || ""} />
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="input-box  active-grey">
                                        <label className="input-label">Estado de Transação</label>
                                        <input type="text" className="input-1"
                                            name="trans_msg"
                                            onChange={this.handelChange}
                                            value={this.state.form.trans_msg || ""} />
                                    </div>
                                </div>
                                <div className="col-md-12">

                                    <div className="input-box active-grey">
                                        <label className="input-label">Observações</label>
                                        <textarea name="Comment" onChange={this.handelChange}
                                            defaultValue={this.state.form.Comment || ""}
                                            className="form-control heigh-auto" rows="3"
                                        ></textarea>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <p><strong>Selecione o método de pagamento</strong></p>
                                        <div className="row">
                                            {
                                                this.state.TransMethods_list &&
                                                this.state.TransMethods_list.map((_r, i) => (
                                                    <div className="col-md-3">
                                                        <input type="radio"
                                                            className="mr-1"
                                                            defaultChecked={parseInt(_r.id) === 7}
                                                            name="selectPaymentMethod" value={_r.id} onClick={() => this.setPaymentMethodid(_r.id)} />{_r.type}
                                                    </div>
                                                ))
                                            }
                                        </div>
                                    </div>
                                </div>
                                {/* {
                                    this.state.amountDetails &&
                                    this.state.AmountDetailsInputs
                                } */}
                            </div>
                            }
                        </div>

                    }
                </div>
            </>
        )
    }
}

export default TransferirModal;